import { logout } from "./logout";

export const baseUrl = "https://api.alfatabelas.com.br";

export async function isUnautorized(response) {
  if (response.status === 401 || response.status === 403) {
    logout();
  }
}

export async function fetchWithAuth(url, options, useAuth = true) {
  if (useAuth) {
    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    };
  }

  const response = await fetch(url, options);

  if (
    response.status === 401 ||
    response.status === 403 ||
    response.status === 422
  ) {
    logout();
    throw new Error("Unauthorized or Forbidden - user logged out");
  }

  if (!response.ok) {
    console.log(
      "Erro na resposta da API:",
      response.status,
      response.statusText,
    );
    const error = new Error("Network response was not ok");
    error.status = response.status;
    throw error;
  }

  const data = await response.json();

  if (!data) {
    throw new Error("Resposta vazia da API");
  }

  return data;
}
